<template>
<div>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="dialogTitle" center width="600px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog h100p">
          <!-- 搜索前 -->
          <div class="waitSearch df-l-c-fs" v-if="step==='waitSearch'">
            <div class="box box1 df-c-ct">
              <input type="text" class="input f-s" :placeholder="$t('member.searchContent')" v-model="searchKey" ref="input1" />
              <div class="icon df-c-ct" @click="inputFocus('input1')">
                <img src="@/assets/icons/scan.png" style="width:22px;height:22px;">
              </div>
            </div>
            <div class="df">
              <div class="whitebtn" @click="searchClearClick">{{$t('common.clear')}}</div>
              <div class="ml60" :class="searchKey!==''?'themebtn':'whitebtn'" @click="searchClick">{{$t('member.search')}}</div>
            </div>
          </div>
          <!-- 搜索后 -->
          <div class="searched df-l-c-fs" v-else-if="step==='searched'">
            <div class="df-c-sb">
              <div class="box box2 df-c-ct">
                <input type="text" class="input f-s" :placeholder="$t('member.searchContent')" v-model="searchKey" ref="input2" />
                <div class="icon df-c-ct" @click="inputFocus('input2')">
                  <img src="@/assets/icons/scan.png" style="width:22px;height:22px;">
                </div>
              </div>
              <div class="ml10 themebtn-s" @click="searchClick">{{$t('member.search')}}</div>
              <div class="ml10 whitebtn-s" @click="searchClearClick">{{$t('common.clear')}}</div>
            </div>
            <div class="card br24">
              <div class="row df-c-fs f-white f-m">{{$t('member.memberId')}}：{{customerData.id}}</div>
              <div class="row df-c-fs f-white f-m">{{$t('member.memberNickname')}}：{{customerData.nickName||customerData.name}}</div>
              <div class="row df-c-fs f-white f-m">{{$t('member.memberLevel')}}：{{customerData['levelName'+_lang]}}</div>
              <div class="row df-c-fs f-white f-m">{{$t('member.memberPhone')}}：{{customerData.phone}}</div>
              <div class="row df-c-fs f-white f-m">{{$t('member.memberEmail')}}：{{customerData.email}}</div>
              <div class="row df-c-fs _yellowcolor f-xl" v-if="isShowMember&&isShowMemberWallet">{{$t('member.memberBalance')}}：{{customerData.account|toprice}}</div>
              <div class="row df-c-fs _yellowcolor f-xl">{{$t('member.memberScore')}}：{{customerData.score|tothousands}}</div>
              <!-- <div class="row df-c-fs f-white f-xl">
                <div class="mr40 df-l-c-fs _yellowcolor">
                  <div>{{$t('member.memberBalance')}}</div>
                  <div>${{customerData.account}}</div>
                </div>
                <div class="df-l-c-fs _yellowcolor">
                  <div>{{$t('member.memberScore')}}</div>
                  <div>{{customerData.score|tothousands}}</div>
                </div>
              </div> -->
              
              <template v-if="isShowVip">
                <div class="tag tag1 f-white f-xl" @click="openVip" v-if="showOpenBtn">{{$t('member.'+(customerData.vip?'renewVip':'becomeVip'))}}</div>
                <div class="tip tip1 _goldcolor f-xxs" v-if="customerData.vipEndTime">{{$t('member.memberVipEndTime')}}</div>
                <!-- <div class="tip tip2 _goldcolor f-xxs" v-if="customerData.vipEndTime">{{customerData.vipEndDate.replace(/-/g,'/')}}</div> -->
                <div class="tip tip2 _goldcolor f-xxs" v-if="customerData.vipEndTime">{{customerData.vipEndDate}}</div>
              </template>
              <template v-if="isShowMember&&isShowMemberWallet">
                <div class="tag tag2 f-white f-xl" @click="chargeBalance">{{$t('member.charge')}}</div>
                <div class="tag tag3 f-white f-xl" @click="viewBill">{{$t('member.bill')}}</div>
              </template>
            </div>
            <div class="df-c-ct mt40" v-if="step==='searched'&&showBindBtn">
              <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
            </div>
          </div>
          <!-- 开通VIP -->
          <div class="openvip p40" v-else-if="step==='openvip'">
            <div class="df-c-sb f-m counterbox">
              <div>{{$t('member.payVip')}}</div>
              <div class="df-c-fs">
                <div class="mr20">
                  <span class="f-xs pr10 throughline" v-if="vipCost.originCost">${{vipCost.originCost}}/{{['',$t('member.year'),$t('member.month')][vipCost.period]}}</span>
                  <span class="f-red">
                    <span>$</span>
                    <span class="f-xxl f-red">{{vipCost.realCost|tothousands}}</span>
                    <span>/{{['',$t('member.year'),$t('member.month')][vipCost.period]}}</span>
                  </span>
                </div>
                <div class="counter df-c-fs">
                  <img class="btn" :src="iconSubtract1" @click.prevent.stop="tapSubtract()" :class="{'img-to-gray':count<2}">
                  <div class="count">{{count|tothousands}}</div>
                  <img class="btn" :src="iconAdd1" @click.prevent.stop="tapAdd()">
                </div>
              </div>
            </div>
            <div class="f-s mt40 pb40">{{$t('member.time')}}：{{nowTime}}</div>
            <div class="df-ct ai-fe mt40">
              <span class="f-s">{{$t('member.mustCost')}}：</span>
              <span class="f-xxxl f-red">{{vipCost.realCost*count|toprice(2)}}</span>
            </div>
            <div class="df-c-ct mt40">
              <div class="whitebtn" @click="step='searched'">{{$t('common.cancel')}}</div>
              <div class="themebtn ml60" @click="calcVip">{{$t('member.calc')}}</div>
            </div>
          </div>
          <!-- 充值 -->
          <div class="charge" v-else-if="step==='charge'">
            <div class="df-c-sb pb10 top">
              <div class="texts">
                <div class="_themecolor f-xs">{{$t('member.memberNickname')}}：{{customerData.nickName||customerData.name}}</div>
                <div class="_themecolor f-xs">{{$t('member.memberPhone')}}：{{customerData.phone}}</div>
                <div class="_themecolor f-xs">{{$t('member.memberEmail')}}：{{customerData.email}}</div>
              </div>
              <div class="topright">
                <div class="_goldcolor f-xxl">{{$t('member.memberBalance')}}：{{customerData.account|toprice}}</div>
              </div>
            </div>
            <div class="df-c-fs ptb10 _bordertop _borderbottom center">
              <div class="card df-l-c-fs _themeborder mr10" :class="chargeIndex===i1?'_themebackground _cf':'_themecolor'" v-for="(x1,i1) in charges" :key="i1" @click="selectChargeItem(i1)">
                <div class="f1 df-l-c-ct">
                  <div class="f-xxxl" :class="chargeIndex===i1?'_cf':'_goldcolor'">{{x1.price|toprice}}</div>
                </div>
                <div class="sub f1 df-l-c-fs">
                  <div :class="{'f-xs':lang==='zh','f-xxxs':lang==='en'}" v-if="x1.sendPrice">{{$t('member.giveAmount1')}}{{x1.sendPrice|toprice}}{{$t('member.giveAmount2')}}</div>
                  <div :class="{'f-xs':lang==='zh','f-xxxs':lang==='en'}" v-if="x1.score">{{$t('member.giveScore1')}}{{x1.score}}{{$t('member.giveScore2')}}</div>
                  <div :class="{'f-xs':lang==='zh','f-xxxs':lang==='en'}" v-if="x1.ticketList&&x1.ticketList.length">{{$t('member.giveCoupons')}}</div>
                </div>
              </div>
            </div>
            <div class="df ai-fe mt10">
              <span class="f-s">{{$t('member.chargeAmount')}}：</span>
              <span class="f-xxxl f-red">{{(charges[chargeIndex]&&charges[chargeIndex].price)|toprice}}</span>
            </div>
            <div class="df-c-ct mtb40">
              <div class="whitebtn" @click="step='searched'">{{$t('common.cancel')}}</div>
              <div class="ml60" :class="chargeIndex!==''?'themebtn':'whitebtn'" @click="calcBalance">{{$t('member.calc')}}</div>
            </div>
          </div>
          <!-- 查看账单 -->
          <div class="bill" v-else-if="step==='bill'">
            <div class="df-c-sb pb10 top">
              <div class="texts">
                <div class="_themecolor f-xs">{{$t('member.memberNickname')}}：{{customerData.nickName||customerData.name}}</div>
                <div class="_themecolor f-xs">{{$t('member.memberPhone')}}：{{customerData.phone}}</div>
                <div class="_themecolor f-xs">{{$t('member.memberEmail')}}：{{customerData.email}}</div>
              </div>
              <div class="topright">
                <div class="_goldcolor f-xxl">{{$t('member.memberBalance')}}：{{customerData.account|toprice}}</div>
              </div>
            </div>
            <div class="list _bordertop pt10">
              <div class="df-c-sb" v-for="(x1,i1) in chargeHistory" :key="i1">
                <div class="_themecolor f-xs sls time">{{x1.createDate}}</div>
                <!-- <div class="_themecolor f-xs sls f1">{{x1['shopName'+_lang]}}</div> -->
                <div class="_themecolor f-xs sls type f1">{{x1.changeTypeT}}</div>
                <div class="_themecolor f-xs sls value">{{x1.value|tothousands(true)}}</div>
              </div>
            </div>
            <div class="df-c-ct mtb40">
              <div class="whitebtn" @click="step='searched'">{{$t('common.cancel')}}</div>
            </div>
          </div>

        </div>
      </div>
      <!-- <div class="dialog-btm w100p df-c-sa" v-if="step==='searched'&&showBindBtn">
        <div class="themebtn" @click="submit">{{$t('common.comfirm')}}</div>
      </div> -->
    </div>
  </el-dialog>

  <DialogPayForVip
    ref="DialogPayForVip"
    @paySuccess="paySuccess"
    @close="NavToPrePage" />
</div>
</template>

<script>
import DialogPayForVip from './DialogPayForVip'
export default {
  name: 'DialogMember',
  components: { DialogPayForVip },
  props: {
    showBindBtn: {
      type: Boolean,
      default: false
    },
    showOpenBtn: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isShowDialog: false,
      step: 'waitSearch', // waitSearch searched openvip
      searchKey: '',

      customerData: {},
  
      vipCost: {},
      count: 1,
      nowTime: '',

      openVipOrderData: {},
      bindOrderId: '',

      // #region 余额
      charges: [],
      chargeIndex: 0,
      chargeHistory: [],
      // #endregion
    }
  },
  computed: {
    dialogTitle() {
      switch (this.step) {
        case 'waitSearch':
        case 'searched':
          return this.$t('index.member')
        case 'openvip':
          if (this.customerData.vipEndTime !== 0) {
            return this.$t('member.renewVip')
          } else {
            return this.$t('member.updateVip')
          }
        case 'charge':
          return this.$t('member.charge')
        case 'bill':
          return this.$t('member.bill')
      }
    }
  },
  methods: {
    open(orderId) {
      if (orderId !== undefined) {
        this.bindOrderId = orderId
      }
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.$nextTick(() => {
        this.searchKey = ''
        this.step = 'waitSearch'
        this.count = 1
        this.openVipOrderData = {}
        this.charges = []
        this.chargeIndex = 0
        this.chargeHistory = []
      })
    },
    
    inputFocus(key) {
      this.searchKey = ''
      this.$refs[key].focus()
    },
    // 点击搜索
    searchClick() {
      // console.log(`%c搜索关键字`, 'color: #f00;', this.searchKey)
      if (this.searchKey) {
        const rD = {
          phoneOrEmailOrCode: this.searchKey,
          companyId: this.shop_x.companyId,
          status: 0
        }
        this.$api.user_info_get(rD).then(res => {
          if (res.status == 0) {
            let _Rs = res.data
            // console.log(_Rs)
            if (_Rs.length) {
              this.customerData = _Rs[0]
              this.step = 'searched'
            } else {
              this.$message.warning(this.$t('member.notFindMember'))
            }
          } else { this._status(res) }
        })
      }
    },
    // 清空
    searchClearClick() {
      this.searchKey = ''
    },

    // #region vip开通/续费
    // 开通VIP
    async openVip() {
      // console.log(`%c会员信息-VIP到期时间:`, 'color: #f00;', this.customerData.vipEndTime)
      if (this.customerData.id) {
        this.step = 'openvip'
        await this.getVipCost();
        if (this.customerData.vipEndTime !== 0) {
          this.timeHandler(this.count, this.customerData.vipEndTime)
        }
      }
    },
    // 数字-1
    tapSubtract() {
      if (this.count > 1) {
        this.count--
        if (this.customerData.vipEndTime !== 0) {
          this.timeHandler(this.count, this.customerData.vipEndTime)
        } else {
          this.timeHandler(this.count)
        }
      }
    },
    // 数字+1
    tapAdd() {
      this.count++
      if (this.customerData.vipEndTime !== 0) {
        this.timeHandler(this.count, this.customerData.vipEndTime)
      } else {
        this.timeHandler(this.count)
      }
    },
    // 结算VIP
    calcVip() {
      if (this.customerData.id) {
        const rD = {
          shopId: this.currentShopId,
          customerId: this.customerData.id,
          vipRenewTime: this.count
        }
        this.$api.payment_vip_create(rD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            // console.log(`%c生成的vip支付订单:`, 'color: #f00;', _R)
            this.openVipOrderData = _R
            this.$refs.DialogPayForVip.open(_R)
          } else { this._status(res) }
        })
      }
    },
    // #endregion
    
    // #region 余额充值
    // 打开充值对话框
    async chargeBalance() {
      // console.log('充值')
      const rD = {
        companyId: this.shop_x.companyId,
        enable: true,
      }
      const _R = await this.getData('charge', rD)
      this.charges = _R
      this.chargeIndex = 0
      this.step = 'charge'
    },
    // 选择充值档位
    selectChargeItem(index) {
      this.chargeIndex = index
    },
    // 充值余额
    calcBalance() {
      if (this.chargeIndex === '') {
        return
      }
      if (this.customerData.id) {
        const rD = {
          shopId: this.currentShopId,
          customerId: this.customerData.id,
          rechargeItemId: this.charges[this.chargeIndex].id
        }
        this.$api.payment_balance_create(rD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            // console.log(`%c充值余额:`, 'color: #f00;', _R)
            this.openVipOrderData = _R
            this.$refs.DialogPayForVip.open(_R)
          } else { this._status(res) }
        })
      }
    },
    // #endregion

    // #region 账单
    // 查看账单
    viewBill() {
      // console.log('查看账单')
      const rD = {
        customerId: this.customerData.id,
        companyId: this.shop_x.companyId,
      }
      this.$api.balance_history_search(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          // console.log(`%c查看账单:`, 'color: #f00;', _R)
          this.chargeHistory = _R.map(x1 => {
            // 变化的历史类型，1是充值，2是堂食消费，3是外卖消费，4是外卖平台，5充值赠送，6是管理员修改，7是vip订单，8是邮件消费，9是退款
            x1.changeTypeT = this.$t('member.balanceChangeType' + x1.changeType)
            return x1
          })
          this.step = 'bill'
        } else { this._status(res) }
      })
    },
    // #endregion

    // 支付成功
    paySuccess() {
      // console.log(`%c支付成功`, 'color: #f00;', this.step)
      this.step = 'searched'
      this.searchClick()
    },
    // 后退上一个页面
    NavToPrePage() {
      // console.log(`%c点击了关闭`, 'color: #f00;', )
    },
    // 提交会员信息
    async submit() {
      this.$emit('submitDialog', {
        orderId: this.bindOrderId,
        customerId: this.customerData.id,
        customerName: this.customerData.nickName || this.customerData.name,
      })
      this.close()
    },
    // 获取VIP费用
    async getVipCost() {
      const rD = {
        companyId: this.shop_x.companyId
      }
      const _R = await this.getData('vipcost', rD)
      // console.log(`%cvip付费:`, 'color: #f00;', _R)
      this.vipCost = _R
      this.timeHandler(1)
    },
    // 时间处理器
    timeHandler(num, target) {
      const TIME_START = target ? this.$tool.time_parse_ymd(target) : this.$tool.time_parse_ymd()
      let TIME_END = ''
      // console.log(`%cTIME_START:`, 'color: #f00;', TIME_START)
      if (this.vipCost.period === 1) {
        TIME_END = this.$tool.time_get_ymd_after_n_year(TIME_START, num)
      } else if (this.vipCost.period === 2) {
        TIME_END = this.$tool.time_get_ymd_after_n_month(TIME_START, num)
      }
      this.nowTime = `${TIME_START.replace(/-/g, '.')}-${TIME_END.replace(/-/g, '.')}`
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 30px 20px;box-sizing: border-box;

  .waitSearch .box, .searched .box{
    position: relative;
    .input{width: 440px;height: 40px;padding: 0 40px 0 10px;box-sizing: border-box;}
    .icon{width: 40px;height: 40px;position: absolute;right: 0;top: 0;bottom: 0;margin: auto;}
  }

  .waitSearch{
    .box1{padding: 80px 0;}
  }

  .searched{
    .box2 .input{width: 300px;}
    .card{
      width: 500px;min-height: 250px;margin-top: 40px;padding: 12px 30px;box-sizing: border-box;
      background: linear-gradient(317deg, #384A77 0%, #6999FF 100%);
      box-shadow: 0px 2px 7px 0px rgba(55, 73, 119, 0.58);
      position: relative;
      .row{line-height: 36px;opacity: .9;}
      .tag{
        width: 112px;text-align: center;border-radius: 4px;border: 1px solid #fff;
        position: absolute;line-height: 38px;opacity: .5;z-index: 10;
      }
      .tag1{right: 30px;top: 12px;}
      .tag2{right: 30px;bottom: 62px;}
      .tag3{right: 30px;bottom: 12px;}
      .tip{width: 114px;text-align: center;position: absolute;right: 30px;}
      .tip1{top: 62px;}
      .tip2{top: 82px;}
    }
  }

  .openvip{
    .counterbox{
      box-sizing: border-box;
      .counter{
        .btn{width: 24px;height: 24px;}
        .count{padding: 0 10px;}
      }
    }
  }
  .charge,.bill{
    .top .texts{line-height: 22px;}
    .center{
      overflow: auto hidden;
      .card{
        width: 120px;height: 180px;border-radius: 8px;flex-shrink: 0;
        .sub{line-height: 24px;}
      }
    }
    .list{
      line-height: 24px;height: 180px;overflow: hidden auto;
      .time{width: 192px;}
      .type{text-align: center;}
      .value{width: 80px;text-align: right;}
    }
  }
}
</style>